module.exports = __webpack_public_path__ + "f6051720c988440eb9763f5d5207ca52.jpg";